const includeAdditionalProperties = (properties?: { [key: string]: string }) => {
  const additionalProperties = { source: 'browser' };

  return properties ? Object.assign(additionalProperties, properties) : additionalProperties;
};

export default includeAdditionalProperties;
